export const HORIZONTAL_NODE_GAP = 38;
export const VERTICAL_NODE_GAP = 140;
export const HORIZONTAL_EDGE_OFFSET = 250;
export const OTHER_MEMBERS_MARGIN_TOP = 54;
export const NODE_WIDTH_DEFAULT = 200;
export const NODE_WIDTH_LONG = 260;
export const FAMILY_MEMBER_HEIGHT = 90;
export const OTHER_MEMBERS_SECTION_HEIGHT_WITH_MEMBERS = 230;
export const OTHER_MEMBERS_SECTION_HEIGHT_EMPTY = 130;
export const OTHER_MEMBERS_SECTION_HEIGHT_FALLBACK = 296;
export const CLUSTER_MIN_NODES = 10;
export const CLUSTER_GAP = HORIZONTAL_NODE_GAP * 3;
